import React, { useState, useEffect } from "react";
import { getExcursionsData } from "../../controllers/ExcursionController";
import ExcursionBox from "./ExcursionBox";
import "./ExcursionsList.css";

function ExcursionsList({ onSelectExcursion }) {
    const [isLoading, setIsLoading] = useState(true);
    const [excursions, setExcursions] = useState([]);

    useEffect(() => {
        getExcursionsData()
            .then((data) => {
                console.log("API Response:", data);
                setIsLoading(false);
                setExcursions(data);
            })
            .catch((error) => {
                console.error("Error fetching excursions:", error);
                setIsLoading(false);
                setExcursions([]);
            });
    }, []);

    if (isLoading) {
        return <p>Loading...</p>;
    }

    return (
        <div className="navigation">
            <ul>
                {Array.isArray(excursions) && excursions.length > 0 ? (
                    excursions.map((excursion, index) => (
                        <li key={index}>
                            <ExcursionBox
                                id={excursion.id}
                                name={excursion.name}
                                creator_id={excursion.creator_id}
                                is_active={excursion.is_active}
                                onClick={() => onSelectExcursion(excursion)}
                            />
                        </li>
                    ))
                ) : (
                    <li>Excursions list is empty</li>
                )}
            </ul>
        </div>
    );    
}

export default ExcursionsList;